export default function ImageExpand () {
    let expandExists = document.getElementsByClassName('mediablock__action').length;

    const mediaItems = document.querySelectorAll('.mediablock');
    const toggleClass = 'mediablock--media-enlarged';
    const contentBody = document.body;

    let scrollPosition = 0;

    const preserveScroll = () => {
        contentBody.style.position = '';
        contentBody.style.top = 0;
        window.scrollTo(0, scrollPosition);
        scrollPosition = 0;
    };

    const fixScroll = (scrollY) => {
        contentBody.style.position = 'fixed';
        contentBody.style.top = `-${scrollY}px`;
        contentBody.style.width = '100%';
        scrollPosition = scrollY;
    };

    const fn = {
        init: function () {

            mediaItems.forEach(mediaItem => {
                mediaItem.querySelector('.mediablock__action').addEventListener('click', function handleClick(event) {
                    mediaItem.classList.add(toggleClass);
                    fixScroll(window.scrollY);
                });

                mediaItem.querySelector('.mediablock__image').addEventListener('click', function handleClick(event) {
                    if (event.target.tagName !== 'IMG') {
                        mediaItem.classList.remove(toggleClass);
                        preserveScroll();
                    }
                });
            });
        }
    };

    if (expandExists) {
        fn.init();   
    }
}